import { render, staticRenderFns } from "./PriceRangeFilterAccordion.vue?vue&type=template&id=39756876&"
import script from "./PriceRangeFilterAccordion.vue?vue&type=script&lang=js&"
export * from "./PriceRangeFilterAccordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports